export function startReports(state, payload) {
  return {
    ...state,
    loading: payload,
  };
}

export function setReports(state, payload) {
  return {
    ...state,
    reports: payload,
  };
}

export function setAudience(state, payload) {
  return {
    ...state,
    audience: {
      ...state.audience,
      ...payload,
    },
  };
}
